module.exports = __webpack_public_path__ + "img/kx3.b6e7230a.png";